import {
    TFundingRequirement,
    TIdVerificationPerson
} from './fundingRequirements.types';

// The first person on the id_verification requirement who has been sent their ID check SMS and not finished it yet.
export const getIdVerificationPersonInReview = ({
    people = []
}: TFundingRequirement): TIdVerificationPerson | undefined =>
    people.find(({ status }) => status === 'in_review');
